import React, { useState } from 'react';
import { Pagination } from 'react-bootstrap';

const PaginationComponent = ({ currentPage, totalPages, onPageChange }) => {
    const [showAllPages, setShowAllPages] = useState(false);

    const handlePageClick = (page) => {
        if (page >= 1 && page <= totalPages) {
            onPageChange(page);
        }
    };

    const renderPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 5;
        let startPage = Math.max(currentPage - 2, 1);
        let endPage = Math.min(startPage + maxPagesToShow - 1, totalPages);
    
        // Adjust startPage if we're near the end
        if (endPage - startPage < maxPagesToShow - 1) {
            startPage = Math.max(endPage - maxPagesToShow + 1, 1);
        }
    
        if (startPage > 1) {
            pages.push(
                <Pagination.Item key={1} onClick={() => handlePageClick(1)}>
                    1
                </Pagination.Item>
            );
            if (startPage > 2) {
                pages.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
            }
        }
    
        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <Pagination.Item
                    key={i}
                    active={i === currentPage}
                    onClick={() => handlePageClick(i)}
                >
                    {i}
                </Pagination.Item>
            );
        }
    
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                pages.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
            }
            pages.push(
                <Pagination.Item key={totalPages} onClick={() => handlePageClick(totalPages)}>
                    {totalPages}
                </Pagination.Item>
            );
        }
    
        return pages;
    };
    

    return (
        <Pagination className="justify-content-end mt-3">
            <Pagination.First onClick={() => handlePageClick(1)} disabled={currentPage === 1} />
            <Pagination.Prev onClick={() => handlePageClick(currentPage - 1)} disabled={currentPage === 1} />

            {renderPageNumbers()}

            <Pagination.Next onClick={() => handlePageClick(currentPage + 1)} disabled={currentPage === totalPages} />
            <Pagination.Last onClick={() => handlePageClick(totalPages)} disabled={currentPage === totalPages} />
        </Pagination>
    );
};

export default PaginationComponent;
